<template>
    <div>
        <swiper
            :modules="modules"
            :slides-per-view="1"
            :speed="1200"
            :loop="false"
            :pagination="{
                type: 'bullets',
                clickable: 'true',
            }"
        >
            <swiper-slide v-for="(item) in props.sliderData">
                <render-vnode :v-node="item"/>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import {Autoplay, Pagination, Navigation} from "swiper";
import {Swiper, SwiperSlide} from "swiper/vue";

export default {
    name: "two-level-slider-tab-slider",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        sliderData: Object,
        required: true
    },
    setup(props) {
        return {
            props,
            modules: [Autoplay, Pagination, Navigation],
        }
    }
};
</script>
